const STRINGS = {
  NULL:"No Selection",
  EMPTY:"",
  NA:"N/A",
};

export default STRINGS;